import LeadPreferencesForm from "@/components/LeadPreferencesForm";

interface Props {
  /** Source label saved with the lead (usually the page URL). */
  source?: string;
  /** Neighborhood pre-filled in the lead record. */
  defaultNeighborhood?: string;
  /** Thank-you page used for conversion tracking. */
  thankYouPath?: string;
}

/**
 * "Seja bem-vindo a TopClass Imóveis Premium!" lead qualification block,
 * shared by listing pages and landing pages (desktop + mobile).
 */
const LeadQualificationSection = ({ source, defaultNeighborhood, thankYouPath }: Props) => (
  <section className="py-14 bg-muted" id="perfil">
    <div className="container mx-auto px-4">
      <div className="max-w-2xl mx-auto bg-card rounded-xl shadow-lg p-6 sm:p-8 border border-border">
        <h2 className="font-display text-2xl sm:text-3xl md:text-4xl font-bold text-foreground text-center uppercase tracking-tight">
          Seja bem-vindo a TopClass Imóveis Premium!
        </h2>
        <p className="font-display text-lg sm:text-xl md:text-2xl font-semibold text-foreground text-center mt-3">
          Aqui você encontra o imóvel do jeito que você procura!
        </p>
        <div className="font-body text-sm sm:text-base text-muted-foreground leading-relaxed space-y-3 mt-4">
          <p>
            Preencha este formulário para receber somente sugestões de imóveis de acordo com suas
            preferências, necessidades e faixa de investimento.
          </p>
          <p className="font-bold text-foreground">
            Fique tranquilo, não fazemos Spam e respeitamos a sua privacidade.
          </p>
        </div>
        <LeadPreferencesForm
          source={source || (typeof window !== "undefined" ? window.location.href : "landing")}
          defaultNeighborhood={defaultNeighborhood}
          thankYouPath={thankYouPath}
        />
      </div>
    </div>
  </section>
);

export default LeadQualificationSection;
